import React from 'react';
import Spinner from 'react-spinner';
import RegionalOrganizationTable from './RegionalOrganizationTable';

import fetchContent from '../../helpers/backend-communication';

class RegionalOrganizationList  extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      isLoading: false,
      data: [],
    };

    this.onLoading = this.onLoading.bind(this);
  }

  fetchData(onLoading) {
    this.onLoading(true);
    fetchContent('regionalOrganization')
      .then(responseObject => {
        this.setState({
          data: responseObject.data,
        });
        this.onLoading(false);
      })
      .catch(error => {
        this.onLoading(false);
      });
  }
  componentDidMount() {
    this.fetchData(
      this.props.onLoading
    );
  }

  onLoading(isLoading) {
    this.setState({ isLoading });
  }


  renderContent() {
    let content;

    if (this.state.isLoading) {
      content = (
        <div className="assistance-page-panel__spinner">
          <Spinner />
        </div>
      );
    } else if (this.state.data.length == 0) {
      content = (<div>
        No information reported
      </div>)

    } else {
        content = (
        <div>
          <RegionalOrganizationTable
            data={ this.state.data }
            type ={"test"}
          />
        </div>
        );
    }

    return content;
  }

  render() {
    return (
      <div className="container-fluid">
        { this.renderContent() }
      </div>
    )
  }
}

export default RegionalOrganizationList;



// WEBPACK FOOTER //
// ./src/components/RegionalOrganization/RegionalOrganizationList.js